import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    [t('footer.productCategory')]: [
      { name: t('footer.features'), path: '/product' },
      { name: t('footer.pricing'), path: '/pricing' },
      { name: t('footer.docs'), path: '/docs' },
      { name: t('footer.changelog'), path: '/changelog' },
    ],
    [t('footer.companyCategory')]: [
      { name: t('footer.about'), path: '/company' },
      { name: t('footer.contact'), path: '/contact' },
      { name: t('footer.security'), path: '/security' },
    ],
    [t('footer.legalCategory')]: [
      { name: t('footer.termsOfService'), path: '/legal/terms' },
      { name: t('footer.privacyPolicy'), path: '/legal/privacy' },
      { name: t('footer.acceptableUse'), path: '/legal/aup' },
      { name: t('footer.refundPolicy'), path: '/legal/refund' },
    ],
  };

  return (
    <footer className="border-t border-glass-border bg-deep-black pt-20 pb-10 relative z-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 border border-glass-cyan rotate-45 flex items-center justify-center">
                <div className="w-1.5 h-1.5 bg-glass-cyan rounded-full" />
              </div>
              <span className="font-display font-bold text-lg text-white">
                INFINITY <span className="text-glass-cyan">BLUE</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t('footer.brandDesc')}
            </p>
          </div>

          {/* Links Columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-display font-bold text-white mb-6 uppercase tracking-wider text-sm">
                {category}
              </h4>
              <ul className="space-y-4">
                {links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-gray-500 hover:text-glass-cyan text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-glass-border flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-gray-600">
          <div className="space-y-2">
            <p>{t('footer.copyright', { year: currentYear })}</p>
            <p>{t('footer.brandLine')}</p>
            <p className="opacity-70">{t('footer.address')}</p>
          </div>
          <div className="flex gap-6">
            <a href="mailto:support@getinfinityblue.com" className="hover:text-glass-cyan transition-colors">
              support@getinfinityblue.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
